import { customizeCraftJsComponent } from '../../../helpers';
import { EditorLoader } from '../../EditorLoader';
import EditorPollingLoaderSettings from './EditorPollingLoaderSettings';

export const EditorPollingLoader = customizeCraftJsComponent(EditorLoader, {
	name: 'Polling',
	props: {
		'data-type': 'polling'
	},
	custom: {
		type: 'polling'
	},
	related: {
		settings: EditorPollingLoaderSettings
	}
});
